import React from "react";
import { useSetting, useSettingsActions } from "./SettingsStore.tsx";
import { SelectButton } from "primereact/selectbutton";
import { RegroupingOptions } from "../Constants.ts";
import { withLabels } from "../Labels.ts";
import { useTranslation } from "../../Shared/i18n/useTranslation.ts";


export const AdditionSubtractionSettings = React.memo(function AdditionSubtractionSettings() {
    const {getSettings, setSettings} = useSettingsActions();
    const {regrouping, language} = useSetting((settings) => ({
        regrouping: settings.Regrouping,
        language: settings.Language,
    }));
    const t = useTranslation();

    const regroupingOptionsArray = Object.values(RegroupingOptions);
    regroupingOptionsArray.splice(0, (regroupingOptionsArray.length - 1)/2);

    function handleRegroupingSelection(value: RegroupingOptions) {
        let updatedSettings = {...getSettings()};
        updatedSettings.Regrouping = value;
        setSettings(updatedSettings);
    }
    return(
        <div className='regroupingContainer'>
            <span className='settingLabel'>{t('settings.regrouping')}</span>
            <SelectButton 
                value={regrouping} 
                onChange={(e) => handleRegroupingSelection(e.value)} 
                options={ withLabels(Object.values(RegroupingOptions), language) }
                className='select regrouping'                    
                aria-label={t('settings.regrouping')}
            />
        </div>
    );
});